import { jsx as _jsx } from "react/jsx-runtime";
import { Box, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import InterestsTab from '@ui/pages/Settings/components/InterestsTab';
import { useParams } from 'react-router-dom';
import { useAppDispatch } from '@application/store/useStore';
const InterestsTabContent = () => {
    const theme = useTheme();
    const { t } = useTranslation();
    const { eventId } = useParams();
    const dispatch = useAppDispatch();
    return (_jsx(Box, { children: _jsx(InterestsTab, { type: 'event', showFilters: false, showSearch: false, title: t('events.eventDetails.tags') }) }));
};
export default InterestsTabContent;
